import React from 'react';
import WidgetDataLabel from '../widgets/WidgetDataLabel';
import WidgetData from '../widgets/WidgetData';

type RevenueAndCarsProps = {
    revenue: string;
    cars: string;
    violationPayments?: string;
    violationsPaid?: string;
};

function RevenueAndCars({ revenue, cars, violationPayments, violationsPaid }: RevenueAndCarsProps) {
    // Only spots that share ticket revenue with the owner get a second column.
    const hasTicketColumn = violationPayments !== undefined || violationsPaid !== undefined;
    return (
        <div style={{ display: 'grid', gridTemplateColumns: hasTicketColumn ? '1fr 1fr' : '1fr', gap: '16px' }}>
            <div style={{ display: 'grid', gap: '16px' }}>
                <div>
                    <WidgetDataLabel
                        label="Auto-Started Revenue"
                        tooltip={{
                            title: 'Auto-Started Revenue',
                            message:
                                'As license plates are scanned, rentals are started automatically for drivers with plates already on file with AirGarage',
                        }}
                    />
                    <WidgetData>{revenue}</WidgetData>
                </div>
                <div>
                    <WidgetDataLabel label="Cars Auto-Started" />
                    <WidgetData>{cars}</WidgetData>
                </div>
            </div>
            {hasTicketColumn && (
                <div style={{ display: 'grid', gap: '16px' }}>
                    {violationPayments !== undefined && (
                        <div>
                            <WidgetDataLabel
                                label="Violation Payments"
                                tooltip={{
                                    title: 'Violation Payments',
                                    message:
                                        'Your share of revenue collected from paid parking violations at this location.',
                                }}
                            />
                            <WidgetData>{violationPayments}</WidgetData>
                        </div>
                    )}
                    {violationsPaid !== undefined && (
                        <div>
                            <WidgetDataLabel label="Violations Paid" />
                            <WidgetData>{violationsPaid}</WidgetData>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default RevenueAndCars;
